module.exports = __webpack_public_path__ + "img/erqi2.99cf9d57.png";